import { render, staticRenderFns } from "./priceList.vue?vue&type=template&id=86f1c30a&scoped=true"
import script from "./priceList.vue?vue&type=script&lang=js"
export * from "./priceList.vue?vue&type=script&lang=js"
import style0 from "./priceList.vue?vue&type=style&index=0&id=86f1c30a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86f1c30a",
  null
  
)

export default component.exports